import { useEffect, useState } from 'react';
import { coverageData } from '@/mocks/homeData';

export default function CoverageSection() {
  const [activeCity, setActiveCity] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('.coverage-animate');
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="cobertura" className="py-20 md:py-32 bg-yakis-white relative overflow-hidden">
      {/* Decorative */}
      <div className="absolute top-1/2 left-0 w-96 h-96 bg-yakis-gold/5 rounded-full blur-3xl -translate-y-1/2" />

      <div className="section-container relative z-10">
        {/* Header */}
        <div className="max-w-2xl mb-12 md:mb-16">
          <div className="coverage-animate animate-on-scroll mb-4">
            <span className="text-yakis-gold text-sm font-semibold tracking-wider uppercase">
              Cobertura Nacional
            </span>
          </div>
          <h2 className="coverage-animate animate-on-scroll font-display font-bold text-3xl sm:text-4xl md:text-5xl text-yakis-navy leading-tight">
            Donde tu empresa
            <br />
            <span className="text-yakis-gold">opere, nosotros llegamos</span>
          </h2>
        </div>

        {/* City Tabs */}
        <div className="coverage-animate animate-on-scroll flex gap-3 mb-8 md:mb-12">
          {coverageData.map((city, index) => (
            <button
              key={city.city}
              type="button"
              onClick={() => setActiveCity(index)}
              className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 ${
                activeCity === index
                  ? 'bg-yakis-gold text-yakis-navy shadow-md'
                  : 'bg-white text-yakis-silver hover:bg-yakis-whiteDark'
              }`}
            >
              {city.city}
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          {/* Left - Info */}
          <div className="coverage-animate animate-on-scroll">
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-yakis-gold/15">
                  <i className="ri-map-pin-2-line text-lg text-yakis-gold" />
                </div>
                <h3 className="font-display font-semibold text-xl text-yakis-navy">
                  {coverageData[activeCity].city}
                </h3>
              </div>

              <p className="text-yakis-silver text-base leading-relaxed mb-6">
                {coverageData[activeCity].description}
              </p>

              <div className="mb-6">
                <h4 className="font-display font-medium text-sm text-yakis-navy mb-3">
                  Principales rutas:
                </h4>
                <div className="grid grid-cols-2 gap-2">
                  {coverageData[activeCity].routes.map((route) => (
                    <div
                      key={route}
                      className="flex items-center gap-2 px-3 py-2 bg-yakis-white rounded-lg"
                    >
                      <i className="ri-route-line text-yakis-gold text-sm" />
                      <span className="text-sm text-yakis-silver">{route}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex items-center gap-3 p-4 bg-yakis-gold/5 rounded-xl">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-yakis-gold/20">
                  <i className="ri-bus-line text-sm text-yakis-gold" />
                </div>
                <div>
                  <p className="font-display font-medium text-sm text-yakis-navy">
                    Servicio disponible las 24 horas
                  </p>
                  <p className="text-xs text-yakis-silver">
                    Turnos matutinos, vespertinos y nocturnos
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Map */}
          <div className="coverage-animate animate-on-scroll">
            <div className="rounded-2xl overflow-hidden shadow-lg bg-white">
              <div className="relative w-full h-[400px] md:h-[450px]">
                <iframe
                  title={`Mapa de ${coverageData[activeCity].city}`}
                  src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d150000!2d${coverageData[activeCity].coordinates.lng}!3d${coverageData[activeCity].coordinates.lat}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2z${coverageData[activeCity].coordinates.lat}N+${Math.abs(coverageData[activeCity].coordinates.lng)}W!5e0!3m2!1ses!2smx!4v1`}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="absolute inset-0"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}